import { L, } from '../leaflet/leaflet';
const L_Marker = L.Marker, L_Polyline = L.Polyline, _viewMarkerExtension = {
    initialize(latLng, options, route) {
        L_Marker.prototype.initialize.call(this, latLng, options);
        this._r = route;
    },
    r() { return this._r; },
}, _ViewMarker = L_Marker.extend(_viewMarkerExtension), _editMarkerExtension = {
    initialize(latLng, options, point) {
        L_Marker.prototype.initialize.call(this, latLng, options);
        this._p = point;
    },
    p() { return this._p; },
}, _EditMarker = L_Marker.extend(_editMarkerExtension), _lineExtension = {
    initialize(initialLatLngs, options, line) {
        L_Polyline.prototype.initialize.call(this, initialLatLngs, options);
        this._l = line;
    },
    ln() { return this._l; },
}, _MapLine = L_Polyline.extend(_lineExtension);
export { _ViewMarker, _EditMarker, _MapLine, };
